<template>
  <div>
    <terms-write-link v-for="writeLayout in writeLayouts" :key="`terms${writeLayout}`"
                      :writeLayout="writeLayout" :termsData="termsData"></terms-write-link>
  </div>
</template>

<script>
import TermsWriteLink from "./TermsWriteLink";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import boardValidator from "@/mixins/validators/boardValidator";
import termsUtil from "./termsUtil";

export default {
  name: "TermsWriteComponent",
  mixins: [alertMixins, boardValidator, termsUtil],
  components: {TermsWriteLink},
  inject: ['changeLoading'],
  provide() {
    return {
      termsWriteSetData: this.setData,
    }
  },
  props: {
    termsType: {},
    termsKey: {default: 0},
    termsCategory: '',
  },
  data() {
    return {
      writeLayouts: [],
      writeFunc: '',
      writeApiParamSet: {},
      parsingData: {},
      directUrl: '',
      directType: '',
      writeSuccessType: 1,
      writeFailTypes: {},
      getFunc: '',
      detailApiParamsSet: {},
      termsData: {},
      termsDetailType: '',
      isRunning:false,
    }
  },
  created() {
    this.termsDetailType = this.$route.params.type;
    this.initConfig();
    if (this.termsKey !== 0) {
      this.getTerms();
    }
  },
  mounted() {
    EventBus.$on('writeTerms', this.runWriteConfirm);
    EventBus.$on('updateTerms', this.runUpdateConfirm);
  },
  beforeDestroy() {
    EventBus.$off('writeTerms');
    EventBus.$off('updateTerms');
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setData(key, value) {
      this[key] = value;
    },

    initConfig() {
      let configTerms = this.returnTermsConfig(this.termsType);
      this.writeLayouts = configTerms.writeLayouts;
      this.writeFunc = configTerms.writeFunc;
      this.writeApiParamSet = configTerms.writeApiParamSet;
      this.writeSuccessType = configTerms.writeSuccessType;
      this.writeFailTypes = configTerms.writeFailTypes;
      this.parsingData = configTerms.parsingData;

      this.getFunc = configTerms.getFunc;
      this.detailApiParamsSet = configTerms.detailApiParamsSet;
      this.directUrl = configTerms.directUrl;
      this.directType = configTerms.directType;

    },

    getTerms() {
      let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
      params.id = this.termsKey;
      params.ty = this.termsCategory;
      console.log(params)
      this.$api.$config[this.getFunc](params).then(res => res.Data.Result).then(res => {
        if (res.Info.type != 1 || res.List.length === 0) {
          this.createAlert({
            title: '',
            content: '데이터를 불러올 수 없습니다.',
            btnText: '확인',
            hide: () => {
              this.$router.back();
            }
          });
          return;
        }
        this.termsData = res.List[0];
      })
    },
    runWriteConfirm() {
      this.createConfirm({
        content: '작성한 약관이 바로 시행됩니다.<br>시행 하시겠습니까?',
        confirm: () => {
          this.writeTerms();
        }
      })
    },
    runUpdateConfirm() {
      this.createConfirm({
        content: '작성한 약관이 바로 수정됩니다.<br>수정 하시겠습니까?',
        confirm: () => {
          this.writeTerms();
        }
      })
    },
    writeTerms() {
      if (this.isRunning) {
        return false;
      }
      this.isRunning = true;
      let dataArr = Object.keys(this.parsingData);
      console.log(dataArr)
      this.$validate(dataArr).then(success => {
        if (!success) {
          util.Array.each(this.writeLayouts, (layout, index, arr) => {
            EventBus.$emit(`${layout}Validator`, dataArr);
          });
          this.isRunning = false;
          this.errorAlert('필수정보를 모두 입력해 주세요.');
          return;
        }
        this.changeLoading(true);
        let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
        dataArr = Object.keys(this.parsingData);
        dataArr.forEach(dataKey => {
          params[this.parsingData[dataKey]] = this[dataKey];
        })
        params.c_type = this.termsDetailType;
        if (this.termsKey != 0) {
          params.c_idx = this.termsKey;
        }

        try {
          this.$api.$config[this.writeFunc](params).then(res => res.Data.Result).then(res => {
            let type = this.returnTermsType(res.Info.type);
            if (type != true) {
              this.changeLoading(false);
              this.errorAlert(type);
              this.isRunning = false;
              return false;
            } else {
              this.afterFunc(this.termsKey);
            }
          });

        } catch (e) {
          this.changeLoading(false);
          console.log(e);
        }
      })
    },

    returnTermsType(type) {
      if (type == this.writeSuccessType) {
        return true;
      } else {
        return util.isEmpty(this.writeFailTypes[type]) ? '실패입니다.' : this.writeFailTypes[type]
      }
    },

    afterFunc(key) {
      this.changeLoading(false);
      this.isRunning = false;
      let detailKey = key;
      this.createAlert({
        title: '',
        content: '저장되었습니다.',
        btnText: '확인',
        hide: () => {
          if (this.directType === 'back') {
            this.$router.back();
            return false;
          }
          if (this.directUrl === '') {
            this.writeLayouts = [];
            this.getTerms();
            return false;
          }
          let url = this.directUrl;
          if (this.directType === 'detail') {
            url = url + detailKey;
          }
          this.$router.push(url);
        }
      })
    },


  },
  watch: {},
}
</script>

<style scoped>

</style>